import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const CheckIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10 0C4.47705 0 0 4.47715 0 10C0 15.5229 4.47705 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0ZM10 2C5.58179 2 2 5.58172 2 10C2 14.4183 5.58179 18 10 18C14.4182 18 18 14.4183 18 10C18 8.84127 17.7537 7.74007 17.3105 6.74593L8.41943 16.1934L3.38965 11.3442L4.77759 9.90434L8.35034 13.3486L15.9111 5.31466L17.2168 6.5435C15.9272 3.85577 13.1804 2 10 2Z"
        clipRule="evenodd"
        fill="currentColor"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
